import { Spinner } from 'ui'

export const LoadingState = () => {
  return (
    <div
      id='loading-document-spinner'
      className='z-20 absolute w-full h-full flex items-center justify-center'
    >
      <Spinner />
    </div>
  )
}
